/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import { useStyles } from './styles';
import CommonImages from '../../../commons/images';

function DialogFooter (props) {
    const {
        widget = {},
        widgetTheme = {},
    } = props;

    const classes = useStyles({
        widget,
        widgetTheme,
    });

    return (
        <footer className={classNames(['ecal-footer', classes.footer])} id="ecal-footer">
            <a 
                className={classNames(['Footer__powered', classes.powered, 'ecal-footer-logo'])}
                href="https://ecal.com"
                target="_blank"
                rel="noopener noreferrer"
            >
                <img src={CommonImages.ECAL_FOOTER_LOGO} alt="Footer Logo" />
             </a>
        </footer>
    );
}

DialogFooter.propTypes = {
    widget: PropTypes.any,
    widgetTheme: PropTypes.any,
};

export default observer(DialogFooter);